export default __webpack_public_path__ + "static/media/kz.6acb3f67.svg";